import { render, staticRenderFns } from "./addAssignment.vue?vue&type=template&id=6ca3ce2d&scoped=true&"
import script from "./addAssignment.vue?vue&type=script&lang=js&"
export * from "./addAssignment.vue?vue&type=script&lang=js&"
import style0 from "./addAssignment.vue?vue&type=style&index=0&id=6ca3ce2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca3ce2d",
  null
  
)

export default component.exports